import { useState, useEffect, useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { logout } from '../Components/Login/services/authSlice'
import { clearSession, SESSION_DURATION, SESSION_STORAGE_KEY, startSession } from './sessionStorage'

const WARN_AT = 30
const DANGER_AT = 10

function getInitialTimeLeft(enabled) {
  if (!enabled) return 0
  return startSession()
}

export function useSession(enabled = true) {
  const [timeLeft, setTimeLeft] = useState(() => getInitialTimeLeft(enabled))
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const resetSession = useCallback(() => {
    if (!enabled) return
    startSession()
    setTimeLeft(SESSION_DURATION)
  }, [enabled])

  useEffect(() => {
    if (enabled) resetSession()
  }, [enabled, pathname, resetSession])

  useEffect(() => {
    if (!enabled) return undefined

    const updateTimeLeft = () => {
      const endTime = sessionStorage.getItem(SESSION_STORAGE_KEY)
      const remaining = endTime
        ? Math.ceil((Number(endTime) - Date.now()) / 1000)
        : 0

      if (!Number.isFinite(remaining) || remaining <= 0) {
        clearSession()
        dispatch(logout())
        setTimeLeft(0)
      } else {
        setTimeLeft(remaining)
      }
    }

    updateTimeLeft()
    const timer = setInterval(updateTimeLeft, 1000)
    return () => clearInterval(timer)
  }, [dispatch, enabled])

  useEffect(() => {
    if (enabled && timeLeft === 0) {
      navigate('/', { replace: true })
    }
  }, [enabled, navigate, timeLeft])

  const fmt = (s) =>
    String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0')

  return {
    timeStr: fmt(timeLeft),
    pct: Math.round((timeLeft / SESSION_DURATION) * 100),
    isWarn: timeLeft <= WARN_AT && timeLeft > 0,
    isDanger: timeLeft <= DANGER_AT && timeLeft > 0,
    isExpired: timeLeft === 0,
    resetSession,
    timeLeft,
  }
}